/** sessionStorage key for full onboarding wizard (UI scaffold; no API yet). */
export const ONBOARDING_STATE_KEY = 'symphony_onboarding_state';

export const ONBOARDING_STEPS = {
  company: 1,
  financial: 2,
  locations: 3,
  team: 4,
  done: 5,
};

function newWarehouseRow(overrides = {}) {
  const id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `wh_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  return {
    id,
    name: '',
    address_line1: '',
    address_line2: '',
    city: '',
    postcode: '',
    country: '',
    ...overrides,
  };
}

/** @returns {Record<string, unknown>} */
export function createEmptyOnboardingState() {
  return {
    version: 1,
    account: null,
    company: {
      trading_name: '',
      registered_name: '',
      address_line1: '',
      address_line2: '',
      city: '',
      region: '',
      postcode: '',
      country: '',
      phone: '',
      billing_email: '',
      general_email: '',
      website_url: '',
      logo_file_name: null,
    },
    /** Company / tax IDs and invoice-footer bank details (not payment-processing credentials). */
    financial: {
      company_registration_number: '',
      vat_number: '',
      bank_name: '',
      account_holder_name: '',
      iban: '',
      bic_swift: '',
      sort_code: '',
      account_number: '',
    },
    locations: {
      multiple_sites: false,
      same_as_company_address: true,
      /** When `multiple_sites` is true, must match `warehouses[].id` for the main/default site. */
      default_warehouse_id: null,
      warehouses: [newWarehouseRow({ name: 'Main warehouse' })],
    },
    team: {
      invite_later: true,
      invites: [],
      /** Local + synced role templates: { id?, name, base_role, permission_grants, serverId? } */
      role_templates: [],
    },
  };
}

export { newWarehouseRow };
